var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"beanRules"},[_c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"width":"500px"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"close pointer",on:{"click":function($event){_vm.dialogVisible=false}}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }